
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/first-look-at-joy",
      function () {
        return require("private-next-pages/blog/first-look-at-joy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/first-look-at-joy"])
      });
    }
  